<template>
  <el-dialog style="overflow: hidden" title="新建项目模板" v-loading="loading" element-loading-text="图片正在生成中..." :visible.sync="currentValue" width="100%" :close-on-click-modal="false" fullscreen append-to-body custom-class="preview-build-dialog">
    <div class="preview-build" >
      <!-- <router-link :to="`/templateProjectDetail?id=${id}`"></router-link> -->
      <iframe ref="iframe" v-if="url" :src="url"></iframe>
    </div>
  </el-dialog>
</template>
<script>
import html2canvas from 'html2canvas'
export default {
  props: ['id','value'],
  data() {
    return {
      url: '',
      screenshotData: '',
      loading: true
    }
  },
  created() {
    let {  origin , pathname} = window.location
    this.url = `${origin}${pathname}#/templateProjectDetail?id=${this.id}`
  },
  mounted() {
    window.addEventListener('message', this.handleIframeMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleIframeMessage);
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
  },
  methods: {
    handleIframeMessage(event) {
      if (event.data === 'iframeLoaded') {
        this.captureIframeScreenshot()
      }
    },
    captureIframeScreenshot() {
      setTimeout(() => {
        const iframe = this.$refs.iframe
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document
        html2canvas(iframeDocument.body).then(canvas => {
          this.loading = false
          this.$emit('success', canvas.toDataURL('image/png'))
        }).catch(error => {
          console.error('Error capturing screenshot:', error)
        })
      }, 500)
    }
  }
}
</script>
<style lang="scss">
.preview-build {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: 0 none;
    opacity: 0;
  }
}
.preview-build-dialog {
  border: 0 none;
  margin: 0;
  padding: 0;
  overflow: hidden !important;
  opacity: 0;

  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    padding: 0;
  }
}
.preview-build-dialog + .el-loading-mask {
  background-color: transparent;
  overflow: hidden;
}
</style>
